// Anuva motion (Animation & Interaction Spec v1.0)
// A4 scroll reveal and marquee pausing. Hero animations (A1, A2) are CSS keyframes.
const EASE = 'cubic-bezier(.2,.7,.2,1)';
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
const isMobile = matchMedia('(max-width: 749px)');

// Section headings and every grid child (cards, tiles, promos, reviews) on the home page.
const REVEAL_SELECTOR = [
  '.anuva-cat__head', '.anuva-cat__grid > *',
  '.anuva-ji__head', '.anuva-ji__track > *',
  '.anuva-duo > *',
  '.anuva-ts__heading', '.anuva-ts__tabs', '.anuva-ts__grid > *',
  '.anuva-spot__copy', '.anuva-spot__figure', '.anuva-spot__cta',
  '.anuva-price__heading', '.anuva-price__grid > *',
  '.anuva-edit > *',
  '.anuva-ff__copy-inner', '.anuva-ff__figure',
  '.anuva-rev__heading', '.anuva-rev__track > *',
  '.anuva-ig__head', '.anuva-ig__grid > *',
  '.anuva-blog__head', '.anuva-blog__grid > *',
  '.anuva-nl__inner',
  '.anuva-links__heading', '.anuva-links__list',
].join(',');

let observer;

const reveal = (target) => {
  const index = [...target.parentElement.children].indexOf(target) % 6;
  const mobile = isMobile.matches;
  const animation = target.animate(
    [
      { opacity: 0, transform: `translateY(${mobile ? 24 : 32}px)` },
      { opacity: 1, transform: 'none' },
    ],
    { duration: mobile ? 750 : 850, easing: EASE, fill: 'both', delay: index * 90 }
  );
  animation.finished
    .then(() => {
      target.style.opacity = '';
      animation.cancel();
    })
    .catch(() => {});
};

const initReveals = (root = document) => {
  if (reduceMotion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting, target }) => {
          if (!isIntersecting) return;
          observer.unobserve(target); // animate once
          reveal(target);
        });
      },
      { threshold: isMobile.matches ? 0.1 : 0.12, rootMargin: '0px 0px -40px 0px' }
    );
  }
  root.querySelectorAll(REVEAL_SELECTOR).forEach((el) => {
    if (el.dataset.anuvaReveal) return;
    // Leave anything already on screen at load alone so the first view never flashes.
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) return;
    el.dataset.anuvaReveal = 'pending';
    el.style.opacity = '0'; // hidden until revealed
    observer.observe(el);
  });
};

// A3: pause the benefits marquee when the tab is hidden (hover pause is CSS).
const syncMarquee = () => {
  document.querySelectorAll('.anuva-benefits__track').forEach((track) => {
    track.style.animationPlayState = document.hidden ? 'paused' : '';
  });
};

const init = () => {
  initReveals();
  syncMarquee();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

document.addEventListener('visibilitychange', syncMarquee);
document.addEventListener('shopify:section:load', (event) => initReveals(event.target));
